import React, { forwardRef, useImperativeHandle, useState } from "react";
import useGetSetupFilterOptions from "./useGetSetupFilterOptions";

import TableFilters from "views/SMS/MySMS/TableFilters";
import { Box } from "@material-ui/core";
import SetupTable from "./SetupTable";
import UsersAction from "./UsersAction";
import UserGroupsAction from "./UserGroupsAction";
import useGetReportsTableData from "views/NewReports/Reports/useGetReportsTableData";

const Setup = forwardRef((props, ref) => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [openAction, setOpenAction] = useState({
    isOpen: false,
    currentSelection: null,
    type: null,
  });

  const [filterValues, setFilterValues] = useState({
    category_id: "",
    user_group_id: "",
  });

  const handleSearchTextChange = (value) => {
    setPage(0);
    setSearchText(value);
  };

  const handleFilterChange = (filterId, event) => {
    setFilterValues((prev) => {
      return { ...prev, [filterId]: event.target.value };
    });
  };

  const filterOptions = useGetSetupFilterOptions();

  const { loading, totalCount, tableData, refetch } = useGetReportsTableData(
    filterValues,
    searchText,
    page,
    pageSize,
    "admin"
  );

  const filtersList = [
    {
      name: "category_id",
      options: [
        { id: "", value: "Category (All)" },
        ...(filterOptions?.categories || []),
      ],
    },
    {
      name: "user_group_id",
      options: [
        { id: "", value: "User Group (All)" },
        ...(filterOptions?.user_group || []),
      ],
    },
  ];

  useImperativeHandle(ref, () => ({ refetch }));

  const handleUserAction = (selected) => {
    if (!selected) return;
    setOpenAction({ isOpen: true, currentSelection: selected, type: "users" });
  };
  const handleUserGroupAction = (selected) => {
    if (!selected) return;
    setOpenAction({
      isOpen: true,
      currentSelection: selected,
      type: "user_groups",
    });
  };

  const handleCloseActions = () => {
    setOpenAction({ isOpen: false, currentSelection: null, type: null });
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      style={{ gap: "1rem", padding: "0rem 2rem" }}>
      <TableFilters
        handleFilterChange={handleFilterChange}
        searchText={searchText}
        filterValues={filterValues}
        handleSearchTextChange={handleSearchTextChange}
        filtersList={filtersList}
      />

      <SetupTable
        setPage={setPage}
        page={page}
        setPageSize={setPageSize}
        pageSize={pageSize}
        totalCount={totalCount}
        tableData={tableData}
        loading={loading}
        handleClickUser={handleUserAction}
        handleClickUserGroups={handleUserGroupAction}
      />
      {openAction.isOpen &&
      openAction.currentSelection &&
      openAction.type === "users" ? (
        <UsersAction
          handleCloseAction={handleCloseActions}
          currentSelection={openAction.currentSelection}
          refetch={refetch}
        />
      ) : null}

      {openAction.isOpen &&
      openAction.currentSelection &&
      openAction.type === "user_groups" ? (
        <UserGroupsAction
          handleCloseAction={handleCloseActions}
          currentSelection={openAction.currentSelection}
          refetch={refetch}
        />
      ) : null}
    </Box>
  );
});

export default Setup;
